// extracted by mini-css-extract-plugin
export var contentWrapper = "styles-module--contentWrapper--9b605";
export var download = "styles-module--download--df1d0";
export var downloadRedesign = "styles-module--downloadRedesign--d0aca";
export var downloadWrapper = "styles-module--downloadWrapper--df8fc";
export var hl = "styles-module--hl--d8d9e";
export var imageWrapper = "styles-module--imageWrapper--9390f";
export var innerContainer = "styles-module--innerContainer--c7f06";
export var resultsWrapper = "styles-module--resultsWrapper--cc90a";